export const state = {
  sourceInfo: undefined,
  sourceInfos: [],
  communes: [],
  sousSourceInfo: undefined,
  sousSourceInfos: []
}